import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnTab from "@shared/components/SnTab";
import { showDialog } from "@widgets/CommonDialog";
import SnSearchBtn from "@shared/components/SnSearchBtn";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_SAL_ISU_REG_005_POP_001 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const searchRef = useRef<any>(null);
    //#endregion
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
    });
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
    });
    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);

    const [selectedTabPage, setTapPage] = useState<string>("1");
    //#endregion

    useImperativeHandle(ref, () => ({
      getSelectedRow, // Expose the function as part of an object
    }));

    const getSelectedRow = () => {
      if (selectedTabPage === "1") {
        return [
          gridRefs.current["grid1"].current.getCheckedRows() || [],
          gridRefs.current["grid2"].current.getCheckedRows() || [],
        ];
      } else {
        return [[], []]; // Default case for unknown tab pages
      }
    };

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_SAL_ISU_REG_005_POP_001",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정

          setFormData(mergedData); // 조회조건 초기값
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
          });
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    //#region Button Event
    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const param = {
            id: "sn_sal_isu_reg_005_pop_01_01",
            params: searchRef.current.getFormdata(),
          };

          const data: any = await fnGetDataSet(param);
          if (selectedTabPage === "1") {
            setDataSources({
              grid1: data[0],
              grid2: data[1] || [],
            });

            if (data[0] && data[0].length > 0) {
              await new Promise((resolve) => setTimeout(resolve, 50));

              gridRefs.current["grid1"].current.selectAndFocusRow(0);
            }
          }
          // 2. 첫 번째 행 선택 및 포커스 설정
          gridRefs.current["grid1"].current.selectAndFocusRow(0);
        } catch (error: any) {
          showDialog("error", error.message);
        }
      };
      fetchdatasource();
    };
    //#endregion

    //#region Event Method
    const onFocusedRowChanged = (event: any) => {
      const selectedRow = event; // 클릭한 행 데이터
      if (selectedRow) {
        const cd_cust = selectedRow.cd_cust;
        const cd_exch = selectedRow.cd_exch;
        gridRefs.current["grid2"].current.applyFilters({
          cd_cust: cd_cust,
          cd_exch: cd_exch,
        });
        gridRefs.current["grid2"].current.selectAllFiltered();
      }
      {
        return;
      }
    };

    const onTabChanged = (index: string) => {
      setTapPage(index);
    };
    //#endregion
    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onFocusedRowChanged,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
        },
      }),
      [columns, dataSources]
    );
    return (
      <div>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>

        <div>
          <SnTab
            titles={["반품적용"]}
            width={"100%"}
            onTabChanged={onTabChanged}
            body={[
              <div>
                <div style={{ height: "25vh", marginTop: "10px" }}>
                  <SnGrid
                    ref={gridRefs.current["grid1"]} // Grid Name
                    columnConfig={grids.grid1.columns} // 컬럼 설정 전달
                    rowData={grids.grid1.dataSource} // Datasource
                    etcProps={{
                      isEditable: false,
                      rowSelection: "single",
                      ischeckboxSelection: true,
                    }}
                    events={grids.grid1.events}
                  />
                </div>
                <div style={{ height: "25vh", marginTop: "10px" }}>
                  <SnGrid
                    ref={gridRefs.current["grid2"]} // Grid Name
                    columnConfig={grids.grid2.columns} // 컬럼 설정 전달
                    rowData={grids.grid2.dataSource} // Datasource
                    etcProps={{
                      isEditable: false,
                      rowSelection: "multiple",
                      ischeckboxSelection: true,
                    }}
                  />
                </div>
              </div>,
            ]}
          />
        </div>
      </div>
    );
  }
);

export default SN_SAL_ISU_REG_005_POP_001;
